import InsightsTopicsContent from './InsightsTopicsContent';

export { type InsightsTopicsContentProps } from './InsightsTopicsContent';
export default InsightsTopicsContent;
